import { Delete } from 'ui/icons/action/Delete';
import { DeletableItemDisplayText } from './types';

/**
 * Default text to be displayed in the `<DeleteItemsModal />` component
 */
export const genericDeletableItemDisplayText: DeletableItemDisplayText = {
  actionName: {
    adjective: 'deleted',
    verb: 'delete',
  },
  itemTypeName: {
    singular: 'item',
    plural: 'items',
  },
  actionIcon: Delete,
};

/**
 * Folders text to be displayed in the `<DeleteItemsModal />` component
 */
export const foldersDeletableItemDisplayText: DeletableItemDisplayText = {
  actionName: {
    adjective: 'deleted',
    verb: 'delete',
  },
  itemTypeName: {
    singular: 'folder',
    plural: 'folders',
  },
  actionIcon: Delete,
};
